export default __webpack_public_path__ + "static/media/info-black.cbf95e2d.svg";